import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  valueForOnlyNumericInputTextFields,
  valueForOnlyStringInputTextFields,
} from "utils/helpers";

import {
  selectAdminPriceForm,
  selectAdminPriceLoad,
  selectIsAddModalOpen,
} from "../redux/selector";
import { actions } from "../redux/slice";
import { AdminTableFormState, FieldType, FieldValues } from "../types";

export const CATEGORY_OPTIONS = ["MATERIALS", "WORK", "GENERAL"] as const;

const REQUIRED_FIELDS: Array<keyof AdminTableFormState> = [
  "category",
  "itemId",
  "unit",
  "basePrice",
];

type PriceField = "category" | "itemId" | "unit" | "basePrice";

const normalizePriceFieldValue = (name: PriceField, value: string) => {
  if (FieldValues[name] === FieldType.Number) {
    return valueForOnlyNumericInputTextFields(value);
  }
  return valueForOnlyStringInputTextFields(value);
};

const ADMIN_PRICE_MODAL = "ADMIN_PRICE.MODAL";

export const useAddPriceModal = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const isOpen = useSelector(selectIsAddModalOpen);
  const form = useSelector(selectAdminPriceForm);
  const isLoading = useSelector(selectAdminPriceLoad);

  const onClose = () => {
    if (isLoading) return;
    dispatch(actions.resetForm());
    dispatch(actions.closeAddModal());
  };

  const setField = (name: PriceField, value: string) =>
    dispatch(
      actions.setFormField({
        [name]: normalizePriceFieldValue(name, value),
      }),
    );

  const isValid = REQUIRED_FIELDS.every((field) =>
    Boolean(String(form[field] ?? "").trim()),
  );

  const onSubmit = () => {
    if (!isValid) return;
    dispatch(actions.craeteForm(form));
    dispatch(actions.closeAddModal());
  };

  const label = (key: string) => t(`${ADMIN_PRICE_MODAL}.${key}`);

  return {
    t,
    isOpen,
    form,
    isLoading,
    isValid,
    onClose,
    setField,
    onSubmit,
    label,
    categoryLabel: (value: string) =>
      t(`ADMIN_PRICE.CATEGORY_VALUES.${value}`),
  };
};
